var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile"},[_c('header',[_c('div',{on:{"click":function($event){return _vm.movePath('/ModemSearch')}}},[_c('img',{attrs:{"src":require("../assets/common/kepcologo.svg")}})]),_vm._v(" "),_c('div',{on:{"click":_vm.logout}},[_vm._v("로그아웃")])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-001e4576","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile.vue
// module id = null
// module chunks = 